import { render, staticRenderFns } from "./RefereePanel.vue?vue&type=template&id=dc1de1a6&"
import script from "./RefereePanel.vue?vue&type=script&lang=js&"
export * from "./RefereePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports